/**
 * Determines whether the no-auth Sandbox bypass is allowed on the current
 * hostname. Sandbox is a demo/preview convenience that grants admin access
 * without authentication, so it MUST be disabled on any hostname that the
 * public can reach as the live product.
 *
 * Allowed: localhost, 127.*, Lovable preview iframes (`id-preview--*`),
 * Lovable sandbox dev URLs (`*.lovable.dev`).
 * Blocked: published apex URLs (`apex-innovate-kit.lovable.app`) and any
 * custom production domain.
 */
export function isSandboxAllowedHere(): boolean {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  if (h === "localhost" || h === "127.0.0.1" || h.startsWith("127.")) return true;
  if (h.includes("id-preview--")) return true;
  if (h.endsWith(".lovable.dev")) return true;
  if (h.endsWith(".lovableproject.com")) return true;
  return false;
}